import { auth, db } from "./firebaseConfig";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { setDoc, doc } from "firebase/firestore";

// Sign Up Function
export const signUp = async (email, password) => {
    try {
        // Create user in Firebase Authentication
        const { user } = await createUserWithEmailAndPassword(auth, email, password);
        console.log("User registered!");

        // Create a Firestore document in the "users" collection for the new user
        await setDoc(doc(db, "users", user.uid), {
            email: user.email,
            createdAt: new Date(),
            // role: "user", // Uncomment and adjust if you want to set a default role
        });

        return user;
    } catch (error) {
        console.error("Sign Up Error:", error.message);
    }
};

// Sign In Function
export const signIn = async (email, password) => {
    try {
        await signInWithEmailAndPassword(auth, email, password);
        console.log("User signed in!");
    } catch (error) {
        console.error("Sign In Error:", error.message);
    }
};

// Sign Out Function
export const logout = async () => {
    try {
        await signOut(auth);
        console.log("User signed out!");
    } catch (error) {
        console.error("Logout Error:", error.message);
    }
};
